"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timestampNow = timestampNow;
exports.parseJWTPayload = parseJWTPayload;
exports.calculateJWTTokenExpirationDate = calculateJWTTokenExpirationDate;
exports.calculateOauthTokenExpirationDate = calculateOauthTokenExpirationDate;
exports.isTokenExpired = isTokenExpired;

function timestampNow() {
  return Math.floor(+new Date() / 1000);
}

function parseJWTPayload(token) {
  try {
    var payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch (e) {
    return null;
  }
}

function calculateJWTTokenExpirationDate(payload) {
  if (!payload || !payload.access_token) {
    return 0;
  }

  var token = parseJWTPayload(payload.access_token);

  if (!token) {
    return 0;
  }

  return token.exp ? Number(token.exp) : 0;
}

function calculateOauthTokenExpirationDate(payload) {
  if (!payload || !payload.expires_in) return 0;
  var expires_in = payload.expires_in;
  return timestampNow() + expires_in;
}

function isTokenExpired(expires) {
  return expires ? expires - timestampNow() < 0 : true;
}